import React, { forwardRef, useEffect } from "react"
import { useState, useRef } from "react";

import { Checkbox } from "@/components/ui/checkbox";


import { FilterResponse } from "modules/catalog/types/filterResponse";
import { filterParam } from "modules/catalog/types/filters_params";

import { endPointCatalog} from "modules/main/services/endpoints";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { SlidersHorizontal } from "lucide-react";
import { UserData } from "modules/authentication/types/user-data";


export const FilterBlock:React.FC<{section:string, isSearch:boolean,initialFilters:Array<filterParam>, isDesktop:boolean,data:FilterResponse[]}> = ({section, isSearch,initialFilters,isDesktop,data}) => {
    return (
    (isDesktop)?
    (<FilterForm 
        data={data!!} 
        initialFilters={initialFilters}
        isSearch={isSearch}
        section={section}
        />):
    (<Sheet>
        <SheetTrigger>
            <SlidersHorizontal className="w-5 h-5 text-primary"/>
        </SheetTrigger>
        <SheetContent side={'left'} className="[&>button:first-child]:hidden">
            <SheetHeader>
                <SheetTitle className="text-xs md:text-sm">Filtrar por</SheetTitle>
                <SheetDescription></SheetDescription>
            </SheetHeader>
            <FilterForm 
                data={data!!} 
                initialFilters={initialFilters}
                isSearch={isSearch}
                section={section} />
        </SheetContent>
    </Sheet>)
    )
}

interface FormFilterProps extends React.HTMLAttributes<HTMLFormElement>{
    data:Array<FilterResponse>,
    initialFilters:Array<filterParam>,
    isSearch:boolean,
    section:string
}   

type checkBoxControl = {
    [key: string]: {
        checked: boolean,
        key: string
    }
}

const FilterForm = forwardRef<HTMLFormElement, FormFilterProps>(({
                    data,
                    initialFilters,                                        
                    ...props}, ref) => {
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);
    const [checkedState, setCheckedState] = useState<checkBoxControl>({});
    const [filtersOpen,setFiltersOpen] = useState<boolean>(false);

    useEffect(()=>{
        const initCheckBox:checkBoxControl = {};
        data?.forEach(filter => {
            filter.component.forEach(fc => {
                initCheckBox[`${filter.type}.${fc.key}`] = {
                    "checked": initialFilters.find((f)=> f.name === filter.type)?.value.find(v=>v === fc.key.toString())!== undefined,
                    "key":fc.key.toString()
                }
            });            
        });
        
        setFiltersOpen(initialFilters.length > 0);
        setCheckedState(initCheckBox);
    },[data, initialFilters]);

    const handleSubmit = (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();             
    }

    const checkedHandler = (id:string) => {
        const newCheckBoxState = {
                ...checkedState,
                [id] : {
                    checked: !checkedState[id].checked,
                    key: checkedState[id].key
                }
        }
        setCheckedState(newCheckBoxState);
        const orderBy = props.isSearch?"relevance":"several_options"
        const selectedIds = Object.keys(newCheckBoxState).filter((id)=>newCheckBoxState[id].checked);
        const filter_url = new URL(endPointCatalog(props.section, "", orderBy, []));        
        selectedIds.forEach(id => filter_url.searchParams.append(id.split(".")[0],newCheckBoxState[id].key.toString()));
       /*  // if (newCheckBoxState[id].checked) */
        //     filter_url.searchParams.append(id.split(".")[0],newCheckBoxState[id].key.toString());
        filter_url.searchParams.delete("page");
        // filter_url.searchParams.append("page","1");
        navigate(filter_url.search);
        // navigate("?page=2");
        // formRef.current?.submit(); 
    }    

    return (
    <form ref={formRef} className="grid w-full items-start gap-6 overflow-auto p-0 2xl:p-2 pt-0" onSubmit={handleSubmit}>
        {
        data?.map((filter,index)=>{
            return (
        <fieldset key={index}>
            <Accordion type="multiple" defaultValue={[filtersOpen?index.toString():""]} > {/* TODO: more filters */}
                <AccordionItem value={index.toString()}>
                    <AccordionTrigger className="pt-0"><span className="text-xs font-bold">{filter.display_name}</span></AccordionTrigger>
                    <AccordionContent>
                        <ScrollArea style={{height:`${Math.min(30,filter.component.length*3)}em`}}>
                        {
                    filter.component.map((fc,i)=>{
                        return (
                            <div className="items-top flex space-x-2 w-full my-3" key={i}>     
                                <Checkbox id={fc.key.toString()} onCheckedChange={() => checkedHandler(`${filter.type}.${fc.key}`)} checked={checkedState[`${filter.type}.${fc.key}`]?.checked}/>
                                <div className="grid gap-1.5 leading-none">
                                    <label
                                        htmlFor={fc.key.toString()}
                                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                    >
                                        <span className="text-muted-foreground">{fc.display_name} ({fc.ocurrences})</span>
                                    </label>
                                </div>                    
                            </div>
                        )
                    })
                        }
                        </ScrollArea>
                    </AccordionContent>
                </AccordionItem>
            </Accordion> 
        </fieldset> 
            )
        })
        }
    </form>
    )
})